// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/intelligentDocumentApplication.css
// module id = 352
// module chunks = 1